import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';

export default (function (Id) {
  const { isRequestSuccessed, exec, rst } = useRequest({
    url: '',
    name: 'SEALING_INSPECTION_UNQUALIFIED_DELETE',
    method: 'DELETE',
  });

  useEffect(() => {
    if (Id) {
      exec(`/api/sealing/inspection/inferior/${Id}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Id]);

  return [isRequestSuccessed, rst];
});
